import { render, staticRenderFns } from "./BinLabel.vue?vue&type=template&id=1e922e4b&scoped=true&"
import script from "./BinLabel.vue?vue&type=script&lang=js&"
export * from "./BinLabel.vue?vue&type=script&lang=js&"
import style0 from "./BinLabel.vue?vue&type=style&index=0&id=1e922e4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e922e4b",
  null
  
)

export default component.exports